export const parseNumber = ( num, is_float, min ) => {
	if ( is_float )
	{
		return parseFloat( num );
	}
	
	num += ``;
	num.replace( /\D/g, `` );

	if ( min )
	{
		return Math.floor( num );
	}

	return Math.ceil( num );
};
